module.exports = __webpack_public_path__ + "img/white_plaster.0976ebc6.png";